import { Card, Row, Col, Button, Form } from "react-bootstrap";
import InputFields from "../../shared/utilities/InputFields";
import states from "../../shared/data/States";


export default function OwnerSection(props) {
  const copyAddress = (fromType, toType) => {
    props.setFieldValue(
      [toType + "Street1"],
      props.values[fromType + "Street1"]
    );
    props.setFieldValue(
      [toType + "Street2"],
      props.values[fromType + "Street2"]
    );
    props.setFieldValue([toType + "State"], props.values[fromType + "State"]);
    props.setFieldValue([toType + "City"], props.values[fromType + "City"]);
    props.setFieldValue([toType + "Zip"], props.values[fromType + "Zip"]);
  };

  return (
    <Card style={{ minHeight: "702px" }} className="tempid-card">
      <Card.Header>
        <i className="fa fa-align-justify"></i>
        <strong>Owner</strong>
        <div className="card-header-actions"></div>
      </Card.Header>
      <Card.Body>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerName"
            config={{
              label: "Name",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "12",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        {props.readOnly === false ? (
          <Row className="px-1">
            <Col xs="12" className="p-2">
              <Form.Label
                htmlFor="owner-sameas-checkbox"
                style={{ marginRight: "20px" }}
              >
                Copy from
              </Form.Label>
              <Button
                className="mr-2"
                onClick={() => copyAddress("location", "owner")}
              >
                Location
              </Button>
              <Button
                className="mr-2"
                onClick={() => copyAddress("mailing", "owner")}
              >
                Mailing
              </Button>
              <Button onClick={() => copyAddress("contact", "owner")}>
                Contact
              </Button>
            </Col>
          </Row>
        ) : null}
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerStreet1"
            config={{
              label: "Street1",
              placeholder: "",
              type: "text"
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerStreet2"
            config={{
              label: "Street2",
              placeholder: "",
              type: "text",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerCity"
            config={{
              label: "City",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerState"
            config={{
              label: "State",
              placeholder: "",
              type: "select2",
              data: states,
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerZip"
            config={{
              label: "Zip",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerPhone"
            config={{
              label: "Phone",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerPhoneExt"
            config={{
              label: "Ext",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "3",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="ownerFax"
            config={{
              label: "Fax",
              placeholder: "",
              type: "text",
              col: "xs",
              colWidth: "5",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
      </Card.Body>
    </Card>
  );
}
